export enum actionTypesDelivery {
  ListOfDelivery = "deliveryList",
  IsDeliveryTableRefreshed = "isDeliveryTableRefreshed",
  SelectedDelivery = "selectedDelivery",
  AddRecentUpload = "addRecentUpload",
  SetRecentUploads = "setRecentUploads",
}

export enum actionTypesStockTransfer {
  ListOfStockTransfer = "stockTransferList",
  IsStockTransferTableRefreshed = "isStockTransferTableRefreshed",
  SelectedStockTransfer = "selectedStockTransfer",
}
